import { mapState, mapGetters, mapMutations } from "vuex";
import MultipleFileInput from "@/components/Ui/MultipleFileInput";
import Validator from "@/utils/Validator";

export default {
  name: "TypeRapidInfo",
  components: {
    MultipleFileInput
  },
  data() {
    return {
      input: {
        title: null,
        body: null,
        soundFile: null,
        category: null
      },

      limit: {
        title: 50,
        body: 2000,
        category: 50
      }
    };
  },
  mounted() {
    this.init();
    this.setValidate(this.formIsValid);
  },
  computed: {
    ...mapState({
      values: state => state.noticeForm.values
    }),
    ...mapGetters({
      permittedView: "permission/permittedView",
      deliveryType: "noticeForm/deliveryType"
    }),

    placeholderTitle() {
      return "最大全角" + this.limit.title + "文字";
    },
    placeholderBody() {
      return "最大全角" + this.limit.body + "文字";
    },
    placeholderCategory() {
      return "最大全角" + this.limit.category + "文字";
    },

    formIsValid() {
      return (
        Validator.validText(this.input.title) &&
        Validator.validText(this.input.body)
      );
    },

    jsonb() {
      let jsonb = {
        title: this.input.title,
        body: this.input.body
      };
      if (Validator.validFile(this.input.soundFile)) {
        jsonb.soundFile = this.input.soundFile;
      }
      if (Validator.validText(this.input.category)) {
        jsonb.category = this.input.category;
      }
      console.warn("........", this.input, jsonb);
      return jsonb;
    }
  },
  watch: {
    "input.title": function(to) {
      if (to) {
        this.input.title = Validator.charByteLimit(to, this.limit.title * 2);
      }
    },
    "input.body": function(to) {
      if (to) {
        this.input.body = Validator.charByteLimit(to, this.limit.body * 2);
      }
    },
    "input.category": function(to) {
      if (to) {
        this.input.category = Validator.charByteLimit(
          to,
          this.limit.category * 2
        );
      }
    },

    input: {
      handler: function(to) {
        this.setValidate(this.formIsValid);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: "noticeForm/setValidate"
    }),

    init() {
      Object.keys(this.input).forEach(key => {
        if (
          this.values.inpDeliveryContents &&
          this.values.inpDeliveryContents[key]
        ) {
          this.input[key] = this.values.inpDeliveryContents[key];
        }
      });
    },

    changeFile({ index, file }) {
      this.input.soundFile = file;
    },

    clearCategory() {
      this.input.category = "";
    }
  }
};
